module.exports = __webpack_public_path__ + "static/media/ENER.897941a4.jpg";


//////////////////
// WEBPACK FOOTER
// ./public/maxsizeimages/books/ENER.jpg
// module id = 1738
// module chunks = 1